var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.$route.path != '/login')?_c('navigation-bar'):_vm._e(),_c('v-content',[_c('router-view',{key:_vm.$route.fullPath})],1),(_vm.$route.path != '/login')?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }